import { useEffect, useState } from "react";
import { EN } from "./en";

const KEY = "dobler_lang";
let lang = localStorage.getItem(KEY) || (navigator.language?.toLowerCase().startsWith("es") ? "es" : "en");

export const getLang = () => lang;
export const setLang = (l) => {
  lang = l;
  localStorage.setItem(KEY, l);
  document.documentElement.lang = l;
  window.dispatchEvent(new Event("langchange"));
};

export const t = (s, vars) => {
  if (typeof s !== "string") return s;
  let out = lang === "es" ? s : (EN[s] ?? s);
  if (vars) Object.entries(vars).forEach(([k, v]) => { out = out.split(`{${k}}`).join(v); });
  return out;
};

export const useLang = () => {
  const [l, setL] = useState(lang);
  useEffect(() => {
    const h = () => setL(getLang());
    window.addEventListener("langchange", h);
    return () => window.removeEventListener("langchange", h);
  }, []);
  return [l, setLang];
};

export const fmtDate = (iso, opts) => (iso ? new Date(iso).toLocaleDateString(lang === "es" ? "es-MX" : "en-US", opts) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString(lang === "es" ? "es-MX" : "en-US") : "—");
